import { enableProdMode, TransferState, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { HttpLoaderFactory } from './app/app.browser.module';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { translateBrowserLoaderFactory } from './app/_helpers/translate-browser.loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { AppModule } from './app/app.module';
import { ToastrModule } from 'ngx-toastr';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';


if (environment.production) {
  enableProdMode();
}
document.addEventListener('DOMContentLoaded', () => {
  let time = new Date().getTime();
  fetch(`${environment.apiUrl}/site?${time}`).then(async response => {
    const siteSettingResponse = await response.json();
    if (siteSettingResponse.code == 200) {
      environment.site = siteSettingResponse.site;
      environment.integrations = siteSettingResponse.site.integrations;
    }

    bootstrapApplication(AppComponent, {
      providers: [importProvidersFrom(AppModule, ...(environment.production && environment.integrations?.ga) ?
        [NgxGoogleAnalyticsModule.forRoot(environment.integrations?.ga)] : [],

        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: environment.production,

          registrationStrategy: 'registerWhenStable:10000'
        }),
        ...(environment.production) ? [
          environment.integrations?.gtag?.id && GoogleTagManagerModule.forRoot({ id: environment.integrations.gtag.id }),
        ] : [],
        ToastrModule.forRoot({
          timeOut: 5000,
          preventDuplicates: true,
          closeButton: true
        }),
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: translateBrowserLoaderFactory,
            deps: [HttpClient, TransferState]
          }
        }))]
    }).then(() => {
      if ('serviceWorker' in navigator && environment.production) {
        navigator.serviceWorker.register('ngsw-worker.js');
      }
    })
      .catch(err => console.error(err));
  });

});
